
module.filter('eflNumber', function() {
    return function(val) {
        if (!angular.isNumber(val)) return '';
        else if (val < 2) return 3;
        else if (val < 4) return 4;
        else if (val < 6) return 5;
        else if (val < 9) return 6;
        else if (val < 11) return 7;
        else if (val <= 12) return 8;
        else return '';
    };
});
